import { alertActions }  from '../../store/actions'
import validPassword from "../valid/password";

export const commons = {
  checkPassword,
  isMobile,
  addComma,
  openPdf,
  openSubmitPdf,
  preventKeyDown,
}

/***************
  비밀번호 체크
***************/

function checkPassword(params) {
  const message = validPassword({password: params});

  return dispatch => {
    if (message.length > 0) {
      dispatch(alertActions.error({
        title: "비밀번호",
        message: message
      }))
      return false
    }
    return true
  }
}

/**
 * App Check
 * @returns {boolean}
 */
function isMobile() {
   // return true;
  return window.ReactNativeWebView;
}

/**
 * 천원단위 콤마 추가
 * @param number
 * @returns {string}
 */
function addComma(number) {
  if (isNaN(number) === false && Number.isInteger(number) === false) {
    number = number.toFixed(3);
  }

  return (number + "").replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * PDF OPEN
 * @param fildId
 */
function openPdf(fildId) {
  //FIXME: 앱일 경우에 대한 예외처리
  return window.open("/pdf/" + fildId );
}

/**
 * PDF SUBMIT OPEN
 * @param fildId
 */
function openSubmitPdf(crtSeq) {
  //FIXME: 앱일 경우에 대한 예외처리
  // return window.open("/pdf/submit/" + crtSeq );
  
  // let save = document.createElement('a');
  // save.href = process.env.REACT_APP_API_URL + '/portal/pdf/submit/'+ crtSeq;
  
	// document.location = save.href;

  //file download 로 수정
  let _anchor = document.createElement('a');
  _anchor.style = 'display:none;';
  document.body.appendChild(_anchor);
  
  let url = process.env.REACT_APP_API_URL + '/portal/pdf/submit/'+ crtSeq;
  _anchor.href = url;
  _anchor.click();  
  document.body.removeChild(_anchor);

}
  /*
    input 태그의 number 타입에서 알파벳 e와 - 입력 안되게 막음
  */
function preventKeyDown(){
  var inputBox = document.querySelectorAll("input[type=number]")
    var exp = '/e|"-"/'
    Array.from(inputBox).forEach((k,index)=>{
          k.addEventListener('keydown',(e)=>{
            if(exp.match(e.key))e.preventDefault()
          })
    })
}
